import util from '@bmp-vue/core/api/util'
import ui from '@bmp-vue/core/api/ui'
import Vue from 'vue'
import Axios from 'axios'

const controller = 'Multiplo'
const getToken = () => JSON.parse(localStorage.getItem('user'))?.token;
const url = process.env.VUE_APP_ROOT_API + controller
export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Post: function (acao, dto) {
    var request = { acao: acao, Dto: dto }
    var header = { headers: { acao: acao } }

    return util.Axios.Post(controller, request, header)
  },
  PostFile: function (acao, dto) {
    var request = {}
    var header = {}
    request = { acao: acao, fileDto: dto }
    switch (acao) {
      case 'UploadDocumentoPessoa':
        header = { headers: { acao: acao } }
        break;
      case 'UploadDocumentoProposta':
        header = { headers: { acao: acao } }
        break;
      default:
        return 'Ação inválida para esse tipo de envio'
    }
    return util.Axios.Post(controller + '/PostWithFile', request, header)
  },
  PostSemLoading: function (acao, dto) {
    const request = { acao: acao, Dto: dto }
    const headers = { acao: acao, Authorization: `Bearer ${getToken()}` }
    return Axios.post(url, request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleError)
  },
  convertDateTime (date) {
    var dataConvertida = ui.Format.Date(ui.Parse.Date(date), 'yyyy-MM-dd HH:mm:ss')
    return new Date(dataConvertida)
  },
  GetValuesBoleto: function (linhaDigitavel) {
    return util.Axios.Get(controller + '/GetValuesBoleto', linhaDigitavel)
  },
  GetCodigoParametro: function (id) {
    return util.Axios.Get(controller + '/GetCodigoParametro', id)
  },
  ValidaDadosIniciais (th, response) {
    let msg = 'Foram encontrados problemas no cadastro do cliente.'
    if (response.status === 'ERRO_CLIENTE') { msg = 'Cliente não cadastrado' } else if (response.status.indexOf('PROPOSTA_') >= 0) { msg = 'Já existem propostas cadastradas para esse cliente' } else if (response.status.indexOf('ERRO_CUSTOMIZACAO') >= 0) { msg = 'Falha na customização do cliente' } else if (response.status.indexOf('ERRO_LIMITE_CREDITO') >= 0) { msg = 'Falha ao carregar limite de crédito do cliente' }
    th.$api.UI.ShowError('Erro Cadastro Cliente', msg)
  },
  GerarCCB: function (id) {
    util.Axios.Get(controller + '/GerarCCB/' + id).then(function (response) {
      if (response?.error?.includes('Bad Request')) {
        ui.ShowAlert('Em Processamento', 'Tente novamente em alguns minutos')
      } else if (ui.PostLoadData(response, true)) {
        var a = document.createElement('a');
        a.href = `data:${response.type};base64,` + response.file;
        a.download = response.name;
        a.click();
      }
    })
  },
  GerarComprovantePagamento: function (id) {
    util.Axios.Get(controller + '/GerarComprovantePagamento/' + id).then(function (response) {
      if (ui.PostLoadData(response, true)) {
        var a = document.createElement('a');
        a.href = `data:${response.type};base64,` + response.file;
        a.download = response.name;
        a.click();
      }
    })
  },
  GetBoletosAgenda: function (codigoProposta) {
    if (!codigoProposta) {
      ui.ShowError('Erro', 'Necessário código da proposta para realizar o download.')
      return;
    }
    util.Axios.Get(controller + '/GetBoletosAgenda/' + codigoProposta).then(function (response) {
      if (ui.PostLoadData(response, true)) {
        if (!response.file || !response.name || !response.type) {
          ui.ShowError('Erro', 'Não foi possivel realizar o download dos Boletos')
          return;
        }

        const a = document.createElement('a');
        a.href = `data:${response.type};base64,${response.file}`;
        a.download = response.name;
        a.style.display = 'none';

        document.body.appendChild(a);
        a.click();

        setTimeout(() => {
          document.body.removeChild(a);
        }, 100);
      }
    })
  },
  GetPDF: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarPDF', dto)
  },
  gerarComprovante: function (dto) {
    return util.Axios.PostBlob(controller + '/gerarComprovante', dto)
  },
  GerarEmail: function (dto) {
    return util.Axios.Post(controller + '/GerarEmail', dto)
  },
  ClearConjuge (model) {
    if (model.EstadoCivil !== 2) {
      Vue.set(model, 'CPFConjuge', null)
      Vue.set(model, 'NomeConjuge', null)
      Vue.set(model, 'RGConjuge', null)
      Vue.set(model, 'TelefoneCelularConjuge', null)
      Vue.set(model, 'EmailConjuge', null)
      if (model.MostrarConjugeCCB) {
        Vue.set(model, 'MostrarConjugeCCB', null)
      }
    }
  },
  GetExcel: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarExcel', dto)
  },
  GetCsv: function (dto) {
    return util.Axios.PostBlob(controller + '/GerarCsv', dto)
  },
  GetMotivosRejeicao (th) {
    this.Post('Select', { filter: { tipoRegistro: 213 } }).then(response => {
      if (ui.PostLoadData(response) && response.JSON) {
        var motivosRejeicao = JSON.parse(response.JSON).filter(i => !i.Description.includes('INATIVO')).map((o) => {
          return { value: o.ID, text: o.Description }
        })
        th.$set(th, 'motivosRejeicao', motivosRejeicao)
      }
    })
  },
  async CarregaDadosPessoa (documento) {
    let dadosCarregados = {}
    const pessoa = await this.Post('SelectPessoa', { filter: { tipoRegistro: 1, DocumentoCliente: ui.Format.SomenteNumeros(documento) } })
    if (pessoa.JSON) {
      dadosCarregados = JSON.parse(pessoa.JSON)
      if (dadosCarregados.DocumentoFederal) {
        const dto = { parameters: [{ name: 'CodigoPessoa', value: dadosCarregados.Codigo }] }
        const endereco = await this.Post('ListPessoaEndereco', dto)
        if (endereco && endereco.Data.length > 0) {
          dadosCarregados.PessoaDadosEndereco = endereco.Data[endereco.Data.length - 1]
          dadosCarregados.PessoaDadosEndereco.CEP = ui.Format.Cep(endereco.Data[endereco.Data.length - 1].CEP)
          dadosCarregados.PessoaDadosEndereco.NroLogradouro = ui.Format.Cep(endereco.Data[endereco.Data.length - 1].NroLogradouro)
        }
        const banco = await this.Post('ListPessoaBanco', dto)
        if (banco && banco.Data.length > 0) {
          dadosCarregados.PessoaDadosBancarios = banco.Data[banco.Data.length - 1]
          dadosCarregados.PessoaDadosBancarios.Conta = banco.Data[banco.Data.length - 1].Conta + '-' + banco.Data[banco.Data.length - 1].ContaDig
          dadosCarregados.PessoaDadosBancarios.CodigoBanco = banco.Data[banco.Data.length - 1].CodigoBanco
          dadosCarregados.PessoaDadosBancarios.Banco = banco.Data[banco.Data.length - 1].BancoDescricao
        }
        return dadosCarregados
      }
    } else {
      return null
    }
  },
  async GetPortalByAmbiente (ambiente) {
    return util.Axios.Get(controller + '/GetPortalByAmbiente', ambiente)
  }
})
